<!--
 * @Author: yuanjianlong
 * @Description: 组件展示
 * @Date: 2021-12-01 11:19:24
 * @LastEditTime: 2021-12-22 11:45:57
 * @FilePath: /teacher-h5/src/demo/switch.vue
-->
<template>
  <div class="h-full p-20 bg-gray-10">
    <div>
      <h1 class="text-h32 mb-20">
        Switch 开关
      </h1>
      <div>
        <div class="mb-20">
          <a-switch default-checked @change="onChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    onChange(e) {
      console.log(e.target.value)
    }
  }
}
</script>

<style>
</style>